// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__o9mNb","content":"styles_content__2BvsZ","sideBar__active":"styles_sideBar__active__GoPP5","main":"styles_main__6awaA"};